/**
 * The Tidy pill (deliverable 23), a `header.pills` registration of order 80: a page an import wrote
 * offers "Review tidy suggestions", which opens 1.F-1's panel. An offer, never forced. This file
 * decides whether to offer it (the flag, the page's newest revisions); the button, which needs the
 * editor, is loaded by `import()` once the page qualifies.
 */
import { flagsFromMe, type SlotComponentProps } from '@codex/contracts';
import { lazy, Suspense } from 'react';
import { useShellSession } from '../shell/session.js';
import { useRevisions } from './data/queries.js';
import { wasImported } from './model/tidy-model.js';

const Button = lazy(() => import('./tidy-pill-button.js'));

export function TidyPill({ docId }: SlotComponentProps) {
  const me = useShellSession();
  const enabled = me !== null && flagsFromMe(me).import === true;
  return enabled ? <TidyPillLoaded docId={docId} /> : null;
}

function TidyPillLoaded({ docId }: { docId: string }) {
  const revisions = useRevisions(docId, true);
  if (!wasImported(revisions.data)) return null;
  return (
    <Suspense fallback={null}>
      <Button docId={docId} />
    </Suspense>
  );
}
